export default __webpack_public_path__ + "ly-logo.b11f933e.svg";